import { Show, type Component, createSignal } from 'solid-js';
import { useNavigate } from '@solidjs/router';
import { ShieldAlert, LogOut } from 'lucide-solid';
import { useAuth } from '~/shared/api/auth-context';
import { authApi } from '~/shared/api/auth-api';
import { useToast } from '~/shared/ui/Toast';

export const ImpersonationBanner: Component = () => {
  const { isImpersonating, session, signIn } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();
  const [exiting, setExiting] = createSignal(false);

  const exit = async () => {
    if (exiting()) return;
    setExiting(true);
    try {
      const operator = await authApi.exitImpersonation();
      signIn(operator);
      navigate('/platform/tenants');
    } catch {
      toast.error('Не удалось выйти из режима клуба');
    } finally {
      setExiting(false);
    }
  };

  return (
    <Show when={isImpersonating()}>
      <div class="flex items-center justify-center gap-3 bg-[hsl(28_100%_50%)] px-4 py-1.5 text-[13px] font-medium text-black">
        <ShieldAlert class="h-4 w-4 shrink-0" />
        <span class="truncate">
          Вы в клубе «{session()?.user.tenantName ?? '—'}» как супер-админ — все действия
          записываются в аудит.
        </span>
        <button
          type="button"
          class="press ml-1 inline-flex shrink-0 items-center gap-1 rounded-md bg-black/15 px-2 py-0.5 hover:bg-black/25 disabled:opacity-60"
          onClick={() => void exit()}
          disabled={exiting()}
        >
          <LogOut class="h-3.5 w-3.5" /> Выйти
        </button>
      </div>
    </Show>
  );
};
